module.exports = __webpack_public_path__ + "static/media/L5.9ca5577e.jpg";